import { j as jsxRuntimeExports } from "./auth-service-tools177.js";

function ComboboxHiddenInput(_ref) {
  let {
    value,
    valuesDivider = ",",
    ...others
  } = _ref;
  return /* @__PURE__ */jsxRuntimeExports.jsx("input", {
    type: "hidden",
    value: Array.isArray(value) ? value.join(valuesDivider) : value || "",
    ...others
  });
}

ComboboxHiddenInput.displayName = "@mantine/core/ComboboxHiddenInput";
export { ComboboxHiddenInput };